import React from 'react';

export const BCinvoiceRow = ({ order }) => {
    return (
        <div className="BCInvoiceItem__row__container">
            <p>
                {order.number}
            </p>
            <p>{order.orderDate}</p>
            <p>{order.totalAmountExcludingTax}</p>
            <p>{order.shipToContact}</p>
            <div className="BCInvoiceItem__row__container__icons">
                <a href={`/api/bcmypages/invoices/pdf/${order.id}`}>
                    <i className="BCInvoiceItem__icon BCInvoiceItem__download"/>
                </a>
            </div>
        </div>
    );
};
